"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utility for getting a property deep on an object using
 * a keyPath array ['pageInfo', 'pageName'] etc
 */
function getDeepValue(targetObject, keyPath) {
    for (var i = 0; i < keyPath.length; i++) {
        // Traverse the keyPath deeper and deeper :D
        if (i < keyPath.length - 1) {
            targetObject = targetObject[keyPath[i]];
        }
        else {
            return targetObject[keyPath[i]];
        }
    }
    return undefined;
}
exports.getDeepValue = getDeepValue;
